<template>
  <span
    class="b-skeleton-compat placeholder"
    :style="styleObj"
  />
</template>

<script>
export default {
  name: 'BSkeleton',
  props: {
    width: { type: String, default: '100%' },
    height: { type: String, default: '1rem' },
    type: { type: String, default: 'text' }, // text | avatar | button | input | ...
    animation: { type: String, default: 'wave' },
  },
  computed: {
    styleObj() {
      return {
        display: 'inline-block',
        width: this.width,
        height: this.type === 'avatar' ? this.width : this.height,
        borderRadius: this.type === 'avatar' ? '50%' : '0.25rem',
      }
    },
  },
}
</script>

<style scoped>
.b-skeleton-compat {
  opacity: 0.5;
}
</style>
